export const TABS_BLOCK = 'tabs_block';
